import { render, staticRenderFns } from "./SoftFairVorversicherung.vue?vue&type=template&id=7428a050&"
import script from "./SoftFairVorversicherung.vue?vue&type=script&lang=js&"
export * from "./SoftFairVorversicherung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports